const list = [
	{
		category: "scratch/platformer",
		title: "Introduction to Sprites",
		//image: "01-cartesian-plane",
		strands: "",
		desc: "What is a sprite? How does Scatch use sprites differently to other programs?",
		url: "https://vimeo.com/336298646"
	},
	{
		category: "scratch/platformer",
		title: "Variables",
		//image: "01-cartesian-plane",
		strands: "",
		desc: "What is a variable and how does Scratch use them to change things on screen?",
		url: "https://vimeo.com/337442314"
	},
	{
		category: "scratch/platformer",
		title: "Code Loops",
		//image: "01-cartesian-plane",
		strands: "",
		desc: "How can we repeat the same commands without recoding all our instructions?",
		url: "https://vimeo.com/336301445"
	},
	{
		category: "scratch/platformer",
		title: "The Cartesian Plane",
		//image: "01-cartesian-plane",
		strands: ["MA3-1WM", "MA3-17MG"],
		desc: "How does Scratch use the cartesian plane to place pictures?",
		url: "https://vimeo.com/337441860"
	},
	{
		category: "scratch/platformer",
		title: "Sprite Origin Points",
		//image: "02-origin-points",
		strands: "",
		desc:
			"What are origin points? And where do you find them on sprites and costumes?",
		url: "https://vimeo.com/399756718"
	},
	{
		category: "scratch/platformer",
		title: "Import Sprite Animations",
		//image: "",
		strands: "",
		desc:
			"How to use itch.io and PiskelApp.com to download and import sprite animations from game artists?",
		url: "https://vimeo.com/399774879"
	}
];

export default list;
